import { createContext } from "preact";
import { Dispatch, StateUpdater, useContext, useState } from "preact/hooks";
import { AppBar, Box, Stack, ToggleButton } from "@mui/material";
import { onLogout } from "../data/auth";
import { FormatListBulleted, Map } from "@mui/icons-material";

import { Wordmark } from "../components/Wordmark";
import { ReactNode } from "preact/compat";
import { useLocation } from "preact-iso";
import {
  MobileToolbar,
  MobileButton,
  MobileToggleButtonGroup
} from "../components/MobileComponents";

const ViewContext = createContext<{
  view: string;
  setView: Dispatch<StateUpdater<string>>;
}>({ view: "", setView: () => false });

export function useViewContext() {
  return useContext(ViewContext);
}

const Main = ({ children }: { children: ReactNode }) => (
  <Box
    component="main"
    sx={{
      padding: 0,
      flexGrow: 1,
      overflow: "auto",
      bgcolor: "background.default"
    }}
  >
    {children}
  </Box>
);

export function MobileLayout({ children }: { children: ReactNode }) {
  const { path } = useLocation();
  const [view, setView] = useState("list");
  const isOnLaunchPage = /\/\d+/.test(path);
  return (
    <Stack sx={{ height: "100dvh" }}>
      <AppBar position="sticky" sx={{ pt: "env(safe-area-inset-top)" }}>
        <MobileToolbar>
          <Wordmark />
          {isOnLaunchPage && (
            <MobileToggleButtonGroup
              value={view}
              onChange={(_e: unknown, v: string | undefined) =>
                v != null && setView(v)
              }
              exclusive
              aria-label="view type"
              size="small"
            >
              <ToggleButton value="list" aria-label="list view">
                <FormatListBulleted />
              </ToggleButton>
              <ToggleButton value="map" aria-label="map view">
                <Map />
              </ToggleButton>
            </MobileToggleButtonGroup>
          )}
          <MobileButton color="inherit" onClick={onLogout}>
            Logout
          </MobileButton>
        </MobileToolbar>
      </AppBar>
      <ViewContext.Provider value={{ view, setView }}>
        <Main>{children}</Main>
      </ViewContext.Provider>
    </Stack>
  );
}
